var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('span',[(_vm.field)?_c('span',[_vm._v(_vm._s(_vm.output[_vm.field]))]):_c('span',[_vm._v(_vm._s(_vm.output))])]):_c('span',[_vm._v("\n    Not Available\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }